<template>
  <div class="pa-wrap">

    <!-- Info Banner -->
    <div class="pa-banner">
      <div class="pa-banner-icon">
        <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="12" y1="16" x2="12.01" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
      </div>
      <div class="pa-banner-text">
        Você pode adicionar até <strong>3 endereços</strong>. Apenas um pode ser definido como principal.
      </div>
      <button
        v-if="!$store.getters['appUserAddress/getMaxAddress'] && $store.getters['appUserAddress/getAddress'].length > 0"
        class="pa-add-btn"
        @click="resetData"
      >
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        Novo endereço
      </button>
    </div>

    <div class="pa-divider-label">
      {{ userDataInfo.id ? 'Editar endereço' : 'Adicionar endereço' }}
    </div>

    <div class="pa-section">

      <!-- CEP row -->
      <div class="pa-row pa-row-cep">
        <div class="pa-field">
          <label class="pa-label">CEP</label>
          <div class="pa-input-wrap" :class="{ 'pa-loading': cepLoading }">
            <svg class="pa-input-icon" width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2"/></svg>
            <input
              v-model="userDataInfo.user_cep"
              class="pa-input"
              placeholder="00000-000"
              maxlength="9"
              @input="onCepInput"
            >
            <span v-if="cepLoading" class="pa-cep-spinner"></span>
          </div>
          <span class="pa-field-hint">Digite o CEP para preencher automaticamente</span>
        </div>
      </div>

      <!-- Endereço + Número -->
      <div class="pa-row">
        <div class="pa-field pa-field-grow">
          <label class="pa-label">Endereço</label>
          <input v-model="userDataInfo.user_rua" class="pa-input pa-input-plain" placeholder="Rua, Avenida, etc.">
        </div>
        <div class="pa-field pa-field-num">
          <label class="pa-label">Número</label>
          <input v-model="userDataInfo.user_nmr" class="pa-input pa-input-plain" type="number" placeholder="Nº">
        </div>
      </div>

      <!-- Complemento + Bairro -->
      <div class="pa-row">
        <div class="pa-field pa-field-grow">
          <label class="pa-label">Complemento</label>
          <input v-model="userDataInfo.user_complemento" class="pa-input pa-input-plain" placeholder="Apto, Bloco, etc.">
        </div>
        <div class="pa-field pa-field-grow">
          <label class="pa-label">Bairro</label>
          <input v-model="userDataInfo.user_bairro" class="pa-input pa-input-plain" placeholder="Bairro">
        </div>
      </div>

      <!-- Cidade + Estado -->
      <div class="pa-row">
        <div class="pa-field pa-field-grow">
          <label class="pa-label">Cidade</label>
          <input v-model="userDataInfo.user_cidade" class="pa-input pa-input-plain" placeholder="Cidade">
        </div>
        <div class="pa-field pa-field-state">
          <label class="pa-label">Estado</label>
          <select v-model="userDataInfo.user_estado" class="pa-input pa-input-plain pa-select">
            <option value="">Selecione</option>
            <option v-for="opt in optionsState" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
          </select>
        </div>
      </div>

    </div>

    <!-- Footer -->
    <div class="pa-footer">
      <button class="pa-btn pa-btn-ghost" type="button" @click="$emit('cencelar')">Cancelar</button>
      <button class="pa-btn pa-btn-primary" type="button" @click="handlSaveAddress">
        <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="currentColor" stroke-width="2"/><polyline points="17 21 17 13 7 13 7 21" stroke="currentColor" stroke-width="2"/><polyline points="7 3 7 8 15 8" stroke="currentColor" stroke-width="2"/></svg>
        {{ userDataInfo.id ? 'Atualizar endereço' : 'Salvar endereço' }}
      </button>
    </div>

  </div>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import toastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'

export default {
  setup() {
    const userData = computed(() => JSON.parse(localStorage.getItem('userData')))
    const toast = useToast()
    const cepLoading = ref(false)

    const userDataInfo = computed({
      get: () => store.state.appUserAddress.currentAddress,
      set: value => store.commit('appUserAddress/SET_CURRENT_ADDRESS', value),
    })

    const resetData = () => { store.dispatch('appUserAddress/reserCuurentAddress') }

    const findAllAddressUser = async () => {
      await store.dispatch('appUserAddress/findAllUser', { id_user: userData.value.id })
    }

    const handlSaveAddress = async () => {
      if (userDataInfo.value.id !== null) {
        await store.dispatch('appUserAddress/updateAddress', {
          id_user: userData.value.id,
          id_address: userDataInfo.value.id,
          data: userDataInfo.value,
        })
          .then(res => {
            resetData()
            findAllAddressUser()
            toast({ component: toastificationContent, props: { title: 'Atualizado', text: res.data.message, icon: 'CheckIcon', variant: 'success' } })
          })
          .catch(err => {
            toast({ component: toastificationContent, props: { title: 'Erro', text: err.response.data.message, icon: 'XCircleIcon', variant: 'danger' } })
          })
      } else {
        await store.dispatch('appUserAddress/createAddress', {
          id_user: userData.value.id,
          data: userDataInfo.value,
        })
          .then(res => {
            resetData()
            findAllAddressUser()
            toast({ component: toastificationContent, props: { title: 'Adicionado', text: res.data.message, icon: 'CheckIcon', variant: 'success' } })
          })
          .catch(err => {
            toast({ component: toastificationContent, props: { title: 'Erro', text: err.response.data.message, icon: 'XCircleIcon', variant: 'danger' } })
          })
      }
    }

    const onCepInput = async event => {
      const cep = event.target ? event.target.value : userDataInfo.value.user_cep
      const cepLimpo = cep.replace(/\D/g, '')
      if (cepLimpo.length === 8) {
        cepLoading.value = true
        try {
          const data = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`).then(res => res.json())
          if (!data.erro) {
            userDataInfo.value.user_rua = data.logradouro || ''
            userDataInfo.value.user_complemento = data.complemento || ''
            userDataInfo.value.user_bairro = data.bairro || ''
            userDataInfo.value.user_cidade = data.localidade || ''
            userDataInfo.value.user_estado = data.uf || ''
          }
        } catch (e) { /* ignore */ }
        cepLoading.value = false
      }
    }

    const optionsState = [
      { value: 'AC', text: 'Acre' }, { value: 'AL', text: 'Alagoas' },
      { value: 'AP', text: 'Amapá' }, { value: 'AM', text: 'Amazonas' },
      { value: 'BA', text: 'Bahia' }, { value: 'CE', text: 'Ceará' },
      { value: 'DF', text: 'Distrito Federal' }, { value: 'ES', text: 'Espírito Santo' },
      { value: 'GO', text: 'Goiás' }, { value: 'MA', text: 'Maranhão' },
      { value: 'MT', text: 'Mato Grosso' }, { value: 'MS', text: 'Mato Grosso do Sul' },
      { value: 'MG', text: 'Minas Gerais' }, { value: 'PA', text: 'Pará' },
      { value: 'PB', text: 'Paraíba' }, { value: 'PR', text: 'Paraná' },
      { value: 'PE', text: 'Pernambuco' }, { value: 'PI', text: 'Piauí' },
      { value: 'RJ', text: 'Rio de Janeiro' }, { value: 'RN', text: 'Rio Grande do Norte' },
      { value: 'RS', text: 'Rio Grande do Sul' }, { value: 'RO', text: 'Rondônia' },
      { value: 'RR', text: 'Roraima' }, { value: 'SC', text: 'Santa Catarina' },
      { value: 'SP', text: 'São Paulo' }, { value: 'SE', text: 'Sergipe' },
      { value: 'TO', text: 'Tocantins' },
    ]

    return { userDataInfo, handlSaveAddress, onCepInput, optionsState, userData, resetData, findAllAddressUser, cepLoading }
  },
}
</script>

<style scoped>
.pa-wrap { background: var(--dk-bg-card, #fff); }

/* ─── Banner ─── */
.pa-banner {
  display: flex; align-items: center; gap: 10px;
  padding: 12px 20px; margin: 16px 24px 0;
  background: rgba(232,106,16,0.06);
  border: 1.5px solid rgba(232,106,16,0.18);
  border-radius: 10px;
}
.pa-banner-icon { color: #E86A10; flex-shrink: 0; }
.pa-banner-text { flex: 1; font-size: 13px; color: var(--dk-text-secondary, #6b7280); }
.pa-banner-text strong { color: var(--dk-text-primary, #0D3349); }

.pa-add-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 7px 14px; border-radius: 8px; border: none; cursor: pointer;
  background: linear-gradient(135deg, #E86A10, #f08535); color: #fff;
  font-size: 13px; font-weight: 600; flex-shrink: 0;
  transition: all 0.15s;
}
.pa-add-btn:hover { background: linear-gradient(135deg, #cf5e0d, #E86A10); }

/* ─── Divider ─── */
.pa-divider-label {
  padding: 10px 24px; margin-top: 16px;
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.08em; color: var(--dk-text-faint, #aab0bc);
  background: var(--dk-bg-card-hover, #fafbfc);
  border-top: 1px solid var(--dk-border-light, #f5f6fa); border-bottom: 1px solid var(--dk-border-light, #f5f6fa);
}

/* ─── Section ─── */
.pa-section { padding: 20px 24px; display: flex; flex-direction: column; gap: 14px; }

.pa-row { display: flex; gap: 12px; align-items: flex-start; }
.pa-row-cep { max-width: 260px; }
.pa-field { display: flex; flex-direction: column; gap: 6px; }
.pa-field-grow { flex: 1; }
.pa-field-num { width: 90px; }
.pa-field-state { width: 140px; }
.pa-label { font-size: 12.5px; font-weight: 600; color: var(--dk-text-primary, #344563); }
.pa-field-hint { font-size: 11.5px; color: var(--dk-text-faint, #aab0bc); }

/* CEP special input */
.pa-input-wrap {
  display: flex; align-items: center; gap: 8px;
  border: 1.5px solid var(--dk-border-input, #e5e8ef); border-radius: 9px;
  padding: 0 12px; background: var(--dk-bg-card, #fff); transition: border-color 0.15s;
}
.pa-input-wrap:focus-within { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.1); }
.pa-input-icon { color: #E86A10; flex-shrink: 0; }
.pa-input-wrap .pa-input {
  flex: 1; padding: 10px 0; border: none; outline: none;
  font-size: 14px; color: var(--dk-text-primary, #1a2d42); background: transparent;
}

/* Plain input */
.pa-input-plain {
  padding: 10px 13px; border-radius: 9px;
  border: 1.5px solid var(--dk-border-input, #e5e8ef); background: var(--dk-bg-card, #fff);
  font-size: 14px; color: var(--dk-text-primary, #1a2d42); outline: none;
  transition: border-color 0.15s; width: 100%;
}
.pa-input-plain:focus { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.1); }
.pa-select { appearance: none; cursor: pointer; }

/* CEP spinner */
.pa-cep-spinner {
  width: 16px; height: 16px; border-radius: 50%; flex-shrink: 0;
  border: 2px solid var(--dk-border-light, #f0f2f5); border-top-color: #E86A10;
  animation: pa-spin 0.8s linear infinite;
}
@keyframes pa-spin { to { transform: rotate(360deg); } }

/* ─── Footer ─── */
.pa-footer {
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 16px 24px; border-top: 1.5px solid var(--dk-border-light, #f5f6fa);
}
.pa-btn {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 9px 18px; border-radius: 9px;
  font-size: 13.5px; font-weight: 600; cursor: pointer; border: none; transition: all 0.15s;
}
.pa-btn-primary { background: linear-gradient(135deg, #E86A10, #f08535); color: #fff; box-shadow: 0 4px 12px rgba(232,106,16,0.25); }
.pa-btn-primary:hover { background: linear-gradient(135deg, #cf5e0d, #E86A10); }
.pa-btn-ghost { background: var(--dk-bg-inset, #f5f6fa); color: var(--dk-text-secondary, #6b7280); }
.pa-btn-ghost:hover { background: var(--dk-bg-card-hover, #edf0f3); }

@media (max-width: 600px) {
  .pa-row { flex-direction: column; }
  .pa-field-num, .pa-field-state { width: 100%; }
  .pa-row-cep { max-width: 100%; }
}
</style>
